import {getFeatureCost, getFeatureUnit} from "./helpers";
import {BATHROOM_VISUALIZER_TYPES} from "../config";
import store from "../store";
import {fakeIntl} from "../translatesProvider";

/**
 * returns feature compressed object that can be passed on the backend (without redundant info)
 * @param fromCartItem {cartItemInterface}
 * @param fromFeature {featureInterface}
 * @param quoteIndex {number}
 * @returns {object}
 */
export const getCompressedFeature = (fromCartItem, fromFeature, quoteIndex = 0) => {
  if (!fromFeature || !fromFeature.dbFeature) {
    return null
  }
  const featureGroup = fromFeature.getParent ? fromFeature.getParent() : null;
  const currentQuote = fromCartItem && Number.isInteger(fromCartItem.currentQuote) ? fromCartItem.currentQuote : quoteIndex;
  const compressedDbFeature = {
    partName: fromFeature.partName,
    sharedFeatureName: fromFeature.dbFeature.sharedFeatureName,
    dbFeatureId: fromFeature.dbFeature.id,
    sku: fromFeature.dbFeature.sku,
    groupName: fromFeature.dbFeature.groupName,
    parentName: featureGroup ? featureGroup.customGroupDisplayName || featureGroup.partName : undefined,
    partId: fromFeature.partId,
    featureDefinitionID: fromFeature.dbFeature.featureDefinitionID,
    noteText: fromFeature.notesList[currentQuote], // we don't restore noteText from here, we take it from getCompressedCartItem
  }
  if (fromFeature.dbFeature.priceWasChanged) {
    compressedDbFeature.customCost = fromFeature.dbFeature.cost; // to restore job feature prices
    compressedDbFeature.customPrice = fromFeature.dbFeature.price; // to restore job feature prices
  }
  if (fromFeature.dbFeature.markUpString) {
    compressedDbFeature.markUpString = fromFeature.dbFeature.markUpString; // to be able to compare! not needed for now
  }
  return compressedDbFeature
}

/**
 * returns cart item compressed object that can be passed on the backend // IS NOT USED IN PARSE RESPONSE ! ONLY NOTE TEXT IS USED
 * @param fromCartItem {cartItemInterface}
 // * @param fromFeature {featureInterface}
 // * @param quoteIndex {number}
 * @returns {object}
 */
export const getCompressedCartItem = (fromCartItem) => {
  if (!fromCartItem) {
    return null
  }
  const compressedCartItem = {
    partId: fromCartItem.partId,
    featureId: fromCartItem.cartFeature.dbFeature.featureDefinition_id,
    sku: fromCartItem.cartFeature.dbFeature.sku,
    quantity: fromCartItem.quantity,
    fabricatorFeatureId: fromCartItem.cartFeature.dbFeature.id,
    calculatedCost: getFeatureCost(fromCartItem.cartFeature, fromCartItem.quantity, fromCartItem.fromQtCategory),
    noteText: fromCartItem.noteText,
    addedBy: fromCartItem.addedBy,
    isRemoved: fromCartItem.isRemoved,
    subGroupTitle: fromCartItem.subGroupTitle,
  }
  if (fromCartItem.cartFeature.dbFeature.priceWasChanged) {
    compressedCartItem.customCost = fromCartItem.cartFeature.dbFeature.cost; // to restore job feature prices
    compressedCartItem.customPrice = fromCartItem.cartFeature.dbFeature.price; // to restore job feature prices
  }
  if (fromCartItem.cartFeature.dbFeature.markUpString) {
    compressedCartItem.markUpString = fromCartItem.cartFeature.dbFeature.markUpString; // to be able to compare! not needed for now
  }
  return compressedCartItem
}

/**
 * returns cart items compressed objects
 * @param cartItems {[cartItemInterface]}
 * @returns {array}
 */
export const getCompressedCartItems = (cartItems) => {
  return cartItems.map(ci => {
    if (!ci.cartFeature || !ci.cartFeature.dbFeature) {
      return null
    }
    const {fabricatorState} = store.getState();
    const units = getFeatureUnit(ci.cartFeature, fakeIntl, fabricatorState, ci.quantity, ci);
    const fabCurrency = fabricatorState.settings.currency;
    const cartItem = Object.assign({}, ci, {
      cartFeature: getCompressedFeature(ci, ci.cartFeature),
      units,
      currency: ci.cartFeature.getFeatureCurrency ? ci.cartFeature.getFeatureCurrency() || fabCurrency : fabCurrency,
    });
    if (ci.relatedProductParent) {
      cartItem.relatedProductParent = getCompressedFeature(ci, ci.relatedProductParent);
    }
    if (ci.bundleParentId) {
      cartItem.bundleParentId = ci.bundleParentId;
    }
    return cartItem
  }).filter(cartItem => !!cartItem)
}

/**
 * sets feature groups properties TO bvState
 * @param bvState {object}
 * @param layout {object}
 * @returns {object}
 */
export const getFeatureGroupsProperties = (bvState, layout) => {
  layout.getFeatures(true).forEach((parentGroup) => {
    let relatedItems = parentGroup.getRelatedItems();
    relatedItems.forEach((subPart) => {
      if (subPart.customNames) {
        bvState[subPart.partId + "_customNames"] = subPart.customNames;
      }
    })
  })
  return bvState
}

/**
 * sets feature groups properties FROM bvState
 * @param bvState {object}
 * @param layout {object}
 * @returns {object}
 */
export const setFeatureGroupsProperties = (bvState, layout) => {
  layout.getFeatures(true).forEach((parentGroup) => {
    let relatedItems = parentGroup.getRelatedItems();
    relatedItems.forEach((subPart) => {
      if (bvState[subPart.partId + "_customNames"]) {
        subPart.customNames = bvState[subPart.partId + "_customNames"];
      }
    })
  })
  return bvState
}


/**
 * adds cookie to request data
 * @param data {object}
 * @returns {object}
 */
export const addGACookie = (data) => {
  try {
    if (!document.cookie) {
      return data
    }
    const getCookie = name => {
      const splitted = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
      return splitted ? splitted[2] : ""
    };
    data.cookiesAll = document.cookie;
    data.cookie_ga = getCookie("_ga");
  } catch (error) {
    console.log("can't access cookie", error);
  }
  return data
}

export const getCartItemPartIdFix = (partId) => {
  if ((partId !== "shower_wall") && (partId !== "shower_interior_wall")) {
    return partId
  }
  const isBathroom = BATHROOM_VISUALIZER_TYPES.includes(document.kvConfig.visualizerType);
  if (isBathroom) {
    if (document.kvConfig.visualizerType === "bvLook") {
      return "shower_wall"
    }
    return "shower_interior_wall"
  }
  return partId // just in case
}

export const fixFeaturesResponse = (response) => {
  if (!response) {
    return []
  }
  if (Array.isArray(response)) {
    return response;
  }
  if (Array.isArray(response.features)) {
    if (Array.isArray(response.relatedFeatures) && response.relatedFeatures.length) {
      // for (let i = 0; i < response.relatedFeatures.length; i++) {
      //   response.relatedFeatures[i].isRelatedDbFeature = true;
      // }
      // console.log("response.relatedFeatures", response.relatedFeatures);
      return [...response.relatedFeatures, ...response.features] // we should always be here // related goes first
    }
    return response.features; // keep it as an array
  }
  return [];
}
